<template>
  <div>
    <el-form :model="form" ref="ruleForm" size="mini" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item required label="企业名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="联系人">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="联系电话">
            <el-input v-model="form.phone" maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="管理员账号">
            <el-input v-model="form.adminphone" maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="授权数量">
            <el-input type="number" v-model="form.peopleNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="授权时间">
            <el-date-picker
              v-model="form.time"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input type="textarea" v-model="form.desc"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否开通OEM">
            <el-checkbox v-model="form.oem"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.oem">
          <el-form-item label="上传图片">
            <div class="upload">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div>
                    <upload
                      type="img"
                      :max="1"
                      ref="field1"
                      @upload="(item) => (form.titlelog = item[0])"
                    ></upload>
                    <span>企业logo</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <upload
                      type="img"
                      ref="field2"
                      :max="1"
                      @upload="(item) => (form.account = item[0])"
                    ></upload>
                    <span>公众号二维码</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <upload
                      type="img"
                      ref="field3"
                      :max="1"
                      @upload="(item) => (form.preSales = item[0])"
                    ></upload>
                    <span>售前二维码</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <upload
                      type="img"
                      :max="1"
                      ref="field4"
                      @upload="(item) => (form.afterSales = item[0])"
                    ></upload>
                    <span>售后二维码</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.oem">
          <el-form-item label="网站名称">
            <el-input v-model="form.webname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.oem">
          <el-form-item label="联系人电话">
            <el-input v-model="form.webphone" maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.oem">
          <el-form-item label="备案号">
            <el-input v-model="form.recordNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.oem">
          <el-form-item label="公网备案">
            <el-input v-model="form.publicSecurityFiling"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.oem">
          <el-form-item label="域名">
            <el-input v-model="form.domain"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmit">{{ btn_msg }}</el-button>
            <el-button @click="close">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import u from "../../../assets/js/util.js";
import upload from "../util/upload.vue";
// import util from "../../../assets/js/util"; //关联下拉选
export default {
  components: { upload },
  name: "add_users",
  props: ["editInfo"],
  data() {
    return {
      btn_msg: "保 存",
      form: {
        name: "",
        username: "",
        adminphone: "",
        phone: "",
        peopleNumber: "",
        time: "",
        desc: "",
        oem: false, //是否开通OEM
        titlelog: "", //企业logo
        preSales: "", //售前
        afterSales: "", //售后
        account: "", //公众号二维码
        webname: "", //网站名称
        webphone: "", //联系人电话
        recordNumber: "", //备案号
        publicSecurityFiling: "", //公网备案
        domain: "", //域名
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "一年",
            onClick(picker) {
              const date = new Date();
              date.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 365);
              picker.$emit("pick", date);
            },
          },
          {
            text: "两年",
            onClick(picker) {
              const date = new Date();
              date.setTime(
                new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 2
              );
              picker.$emit("pick", date);
            },
          },
          {
            text: "三年",
            onClick(picker) {
              const date = new Date();
              date.setTime(
                new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 3
              );
              picker.$emit("pick", date);
            },
          },
          {
            text: "五年",
            onClick(picker) {
              const date = new Date();
              date.setTime(
                new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 5
              );
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  async mounted() {
    if (this.editInfo._id) {
      this.form = JSON.parse(JSON.stringify(this.editInfo));

      this.$nextTick(() => {
        this.$refs.field1.setvalue([this.form.titlelog]);
        this.$refs.field2.setvalue([this.form.preSales]);
        this.$refs.field3.setvalue([this.form.afterSales]);
        this.$refs.field4.setvalue([this.form.account]);

        this.$refs.field1.edit_data([this.form.titlelog]);
        this.$refs.field2.edit_data([this.form.preSales]);
        this.$refs.field3.edit_data([this.form.afterSales]);
        this.$refs.field4.edit_data([this.form.account]);
      });

      // console.log(u.config().static,'u.config().staticu.config().static');
      // // / 处理图片路径
      // this.form.titlelog = this.form.titlelog
      //   ? u.config().static + "/" + this.form.titlelog
      //   : "";
      // this.form.preSales = this.form.preSales
      //   ? u.config().static + "/" + this.form.preSales
      //   : "";
      // this.form.afterSales = this.form.afterSales
      //   ? u.config().static + "/" + this.form.afterSales
      //   : "";
      // this.form.account = this.form.account
      //   ? u.config().static + "/" + this.form.account
      //   : "";
      this.btn_msg = "修改";
    }
  },
  methods: {
    getCallbackUpload(item) {
      this.form.titlelog = item[0];
      // form.titlelog = $event
    },
    close() {
      this.$emit("close");
    },
    async onSubmit(e) {
      var from = this.form;
      if (!from.name) {
        u.error("名称不能空");
        return;
      }
      if (!from.username) {
        u.error("联系人不能空");
        return;
      }
      if (!from.adminphone) {
        u.error("管理员账号不能空");
        return;
      }
      if (!u.isPhone(from.adminphone)) {
        u.error("管理员账号格式不正确");
        return;
      }
      if (!from.phone) {
        u.error("联系电话不能空");
        return;
      }
      if (!u.isPhone(from.phone)) {
        u.error("联系电话格式不正确");
        return;
      }
      if (!u.isPhone(from.phone)) {
        u.error("联系人格式不正确");
        return;
      }
      if (!from.peopleNumber) {
        u.error("授权数量不能空");
        return;
      }
      if (!from.time) {
        u.error("授权时长不能空");
        return;
      }
      if (from._id) {
        var id = this.form._id;
        delete this.form._id;
        var status = await u.post("users", "account_update", {
          table: "enterprise",
          where: { _id: id },
          data: this.form,
        });
        if (status !== false) {
          this.$emit("success", "");
        }
        return;
      } else {
        var account = await u.post("users", "account_list_add", {
          adminphone: from.adminphone,
          name: from.name,
          phone: from.phone,
        });
        if (account === false) {
          return;
        }
        if (account[1] > 0) {
          u.error("联系人手机号、公司名称、管理员账号已经存在");
          return;
        }
        var status = await u.post("users", "account_add", {
          table: "enterprise",
          data: this.form,
        });
        if (status !== false) {
          this.$emit("success", "");
        }
      }
    },
  },
};
</script>

<style scoped>
.el-textarea,
.el-input {
  width: 100%;
}
.upload {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}
.upload span {
  position: relative;
  left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/page/module/admin/add_users.vue